import {Icon, IconProps} from '@chakra-ui/react';

export function BadgesIcon({active, ...props}: IconProps & {active: boolean}) {
  return (
    <Icon width="16px" height="16px" viewBox="0 0 16 16" fill="none" color={active ? '#5AC57B' : 'gray'} {...props}>
      <path
        d="M5.46505 8.37608L6.12456 5.00239L6.15253 4.85932L6.00823 4.8839L4.60156 5.12345L4.52811 5.13595L4.51993 5.20977L4.0175 9.74009L4.00275 9.87305L4.13506 9.85052L5.88884 9.55185L5.79113 12.8456L5.98775 12.8778L7.31074 8.20771L7.35418 8.05437L7.19632 8.08125L5.46505 8.37608Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
      <path
        d="M1.33407 3.33185L5.94091 2.42443L6.33392 1.15356C6.59593 0.301744 7.52797 -0.186618 8.40996 0.0688453L14.8075 1.91108C15.233 2.03358 15.5843 2.30999 15.7971 2.68956C16.0099 3.06913 16.0574 3.50431 15.9297 3.91611L13.0677 13.1837C12.8524 13.8808 12.2182 14.3587 11.5198 14.3587C11.4389 14.3587 11.3605 14.3385 11.2795 14.3248C11.0734 14.4925 10.8273 14.6206 10.5452 14.6762L4.00505 15.9656C3.11055 16.1445 2.22023 15.5804 2.03499 14.7084L0.0340481 5.23453C-0.150358 4.36337 0.432901 3.51075 1.33407 3.33185ZM14.3293 3.45595L7.93267 1.61291L7.79582 2.05856C8.84302 1.85225 9.67327 2.49373 9.84432 3.29961L11.6859 12.0176L14.3293 3.45595ZM3.67295 14.3861L10.2115 13.0967L8.20886 3.62196L1.66868 4.91137L3.67295 14.3861Z"
        fill="currentColor"
      />
    </Icon>
  );
}
